import './font-resize.directive.ajscss';

import templateUrl from './font-resize.directive.html';

export let FontResizeDirective = [
  '$sce',
  $sce => ({
    restrict: 'E',
    templateUrl,
    scope: {
      value: '=',
      lineBreak: '=',
    },
    link: (scope, elem) => {
      scope.$render = () => {
        scope.resize();
      };
      scope.$watch('value', () => {
        scope.resize();
      });
      scope.$watch(
        () => elem[0].offsetHeight,
        (newValue, oldValue) => {
          if (newValue !== oldValue) {
            scope.resize();
          }
        }
      );
      scope.$watch(
        () => elem[0].offsetWidth,
        (newValue, oldValue) => {
          if (newValue !== oldValue) {
            scope.resize();
          }
        }
      );
      elem.addClass('fitedText');
      let inDebounce;
      scope.resize = () => {
        clearTimeout(inDebounce);
        inDebounce = setTimeout(() => {
          if (scope.value !== '') {
            if (elem.children().css('font-size') === '') {
              elem.children().css('font-size', '0px');
            }
            if (scope.lineBreak) {
              while (elem.children()[0].offsetHeight < elem[0].offsetHeight) {
                let newAscSizeHeight = parseInt(elem.children().css('font-size'), 10) + 5;
                elem.children().css('font-size', newAscSizeHeight + 'px');
              }
              while (elem.children()[0].offsetHeight > elem[0].offsetHeight) {
                let newDescSizeHeight = parseInt(elem.children().css('font-size'), 10) - 5;
                elem.children().css('font-size', newDescSizeHeight + 'px');
              }
            } else {
              elem.children().css('display', 'inline-block');
              while (elem.children()[0].offsetHeight < elem[0].offsetHeight && elem.children()[0].offsetWidth < elem[0].offsetWidth) {
                let newAscSizeHeight = parseInt(elem.children().css('font-size'), 10) + 5;
                elem.children().css('font-size', newAscSizeHeight + 'px');
              }
              while (elem.children()[0].offsetHeight > elem[0].offsetHeight || elem.children()[0].offsetWidth > elem[0].offsetWidth) {
                let newDescSizeHeight = parseInt(elem.children().css('font-size'), 10) - 5;
                elem.children().css('font-size', newDescSizeHeight + 'px');
              }
            }
            let marginTop = (elem[0].offsetHeight - elem.children()[0].offsetHeight) / 2;
            elem.children().css('margin-top', marginTop + 'px');
          }
        }, 1000);
      };
      scope.trustAsHtml = s => {
        if (!isNaN(s)) {
          return $sce.trustAsHtml(String(s));
        }
        return $sce.trustAsHtml(s);
      };

      // fix to prevent memory leak
      scope.$on('$destroy', () => {
        // remove listener
      });
      elem.on('$destroy', () => {
        scope.$destroy();
      });
    },
  }),
];

export default 'cngFitText';
